import Contests from '@/modules/contests/Contests.vue';
import UpcomingContests from '@/modules/contests/components/Upcoming.vue';
import LiveContests from '@/modules/contests/components/Live.vue';
import HistoryContests from '@/modules/contests/components/History.vue';
import CreateContest from '@/modules/contests/components/CreateContest.vue';
import ContestCreateTeam from '@/modules/contests/components/CreateTeam.vue';
import ContestDetail from "@/modules/contests/components/ContestDetail.vue";
export default [
    {
        path: '/contests/:id/detail',
        name: 'ContestDetail',
        component: ContestDetail,
        meta: { requiresNavbar: true },
    },
    {
        path: '/contests/:id/lineup',
        name: 'ContestCreateTeam',
        component: ContestCreateTeam,
        meta: { requiresNavbar: true },
    },
    {
        path: '/contests',
        name: 'Contests',
        component: Contests,
        meta: { requiresNavbar: true },
        children: [
            {
                path: '/contests/',
                name: 'Upcoming',
                component: UpcomingContests,
                meta: { requiresNavbar: true },
            },

            {
                path: '/contests/live',
                name: 'Live',
                component: LiveContests,
                meta: { requiresNavbar: true },
            },
            {
                path: '/contests/history',
                name: 'History',
                component: HistoryContests,
                meta: { requiresNavbar: true },
            },
        ],
    },
    {
        path: '/contests/create',
        name: 'Create Contest',
        component: CreateContest,
        meta: { requiresNavbar: true },
    },
];
